import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { Container, Row, Col, Form, Spinner, Toast } from "react-bootstrap";
import axios from "axios";
import "./index.css";
import CustomButton from "../../COMMON/BUTTON";
import { api } from "../../../CONSTANTS";

const ContactForm = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();

  const [cardioScreening, setCardioScreening] = useState("no"); // Default to "no"
  const [loading, setLoading] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastVariant, setToastVariant] = useState("success");

  // Handle form submission
  const onSubmit = async (data) => {
    const formData = {
      ...data,
      cardioScreening,
    };

    setLoading(true);

    try {
      await axios.post(api, formData);
      reset(); // Reset form fields
      setCardioScreening("no"); // Reset cardio screening to default
      setToastMessage("Form submitted successfully!");
      setToastVariant("success");
      setShowToast(true);
    } catch (error) {
      console.error("Submission error:", error);
      setToastMessage(
        "There was an error submitting the form. Please try again."
      );
      setToastVariant("danger");
      setShowToast(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container className="contactForm">
      <Form noValidate onSubmit={handleSubmit(onSubmit)}>
        <FormGroup label="Your Name / Clinic Name" required>
          <Form.Control
            type="text"
            placeholder="Enter your name or clinic name"
            {...register("name", { required: true })}
            isInvalid={!!errors.name}
            className="mb-3"
          />
          <Form.Control.Feedback type="invalid">
            Please enter your name or clinic name.
          </Form.Control.Feedback>
        </FormGroup>

        <FormGroup label="Email" required>
          <Form.Control
            type="email"
            placeholder="example@mysite.com"
            {...register("email", { required: true })}
            isInvalid={!!errors.email}
            className="mb-3"
          />
          <Form.Control.Feedback type="invalid">
            Please enter a valid email address.
          </Form.Control.Feedback>
        </FormGroup>

        <FormGroup label="Phone Number" required>
          <Form.Control
            type="tel"
            placeholder="Enter your phone number"
            {...register("phone", { required: true })}
            isInvalid={!!errors.phone}
            className="mb-3"
          />
          <Form.Control.Feedback type="invalid">
            Please enter a valid phone number.
          </Form.Control.Feedback>
        </FormGroup>

        <FormGroup label="Zipcode" required>
          <Form.Control
            type="text"
            placeholder="Enter your zipcode"
            {...register("zipcode", { required: true })}
            isInvalid={!!errors.zipcode}
            className="mb-3"
          />
          <Form.Control.Feedback type="invalid">
            Please enter your zipcode.
          </Form.Control.Feedback>
        </FormGroup>

        <FormGroup label="Your Title">
          <Form.Control
            type="text"
            placeholder="Your title"
            {...register("title")}
            className="mb-3"
          />
        </FormGroup>

        {/* <Form.Group>
          <Form.Label>
            Do you currently offer cardiovascular screening in your practice?
          </Form.Label>
          <div className="d-flex align-items-center">
            <Form.Check
              type="radio"
              label="Yes"
              value="yes"
              onChange={(e) => setCardioScreening(e.target.value)}
              required
              inline
              checked={cardioScreening === "yes"} // Check if selected
            />
            <Form.Check
              type="radio"
              label="No"
              value="no"
              onChange={(e) => setCardioScreening(e.target.value)}
              required
              inline
              checked={cardioScreening === "no"} // Check if selected
            />
          </div>
        </Form.Group> */}

        <FormGroup label="Message" required>
          <Form.Control
            as="textarea"
            rows={3}
            placeholder="Enter your message"
            {...register("message", { required: true })}
            isInvalid={!!errors.message}
            className="mb-3"
          />
          <Form.Control.Feedback type="invalid">
            Please enter a message.
          </Form.Control.Feedback>
        </FormGroup>

        <Row className="justify-content-center">
          <Col xs="auto mb-3">
            <CustomButton
              variant="secondary"
              type="submit"
              label={
                loading ? <Spinner animation="border" size="sm" /> : "Submit"
              }
              className="formSubmit"
              disabled={loading}
            />
          </Col>
        </Row>
      </Form>

      {/* Toast Notification */}
      <Toast
        onClose={() => setShowToast(false)}
        show={showToast}
        delay={3000}
        autohide
        className={`bg-${toastVariant} text-white position-fixed`}
        style={{ bottom: "20px", right: "20px" }}
      >
        <Toast.Body>{toastMessage}</Toast.Body>
      </Toast>
    </Container>
  );
};

// Reusable FormGroup component for better structure
const FormGroup = ({ label, required, children }) => (
  <Form.Group>
    <Form.Label>
      {label} {required && <span className="text-danger">*</span>}
    </Form.Label>
    {children}
  </Form.Group>
);

export default ContactForm;
